import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
import gsap from 'gsap';
import "jquery-match-height/jquery.matchHeight";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import Lenis from '@studio-freight/lenis'
gsap.registerPlugin(ScrollTrigger);
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import '@fancyapps/fancybox';
import { default as fancybox } from '@fancyapps/fancybox';
import "@fortawesome/fontawesome-free/js/fontawesome.min";
import "@fortawesome/fontawesome-free/js/solid.min";
import "@fortawesome/fontawesome-free/js/regular.min";
import "@fortawesome/fontawesome-free/js/brands.min";

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

import paper from 'paper';

//App imports

import {menuMain} from "./menu";


/****************************************************************************
 * Theme scripts.
 ****************************************************************************/


window.addEventListener('load', function() {
    AOS.refresh();
});


(function( $ ){
    'use strict';

    setTimeout( () => {

        var video = $("#myVideo")[0];
        var playPauseButton = $(".poster");
        var pauseVid = $(".video");

        playPauseButton.click(function() {
            console.log('clicked');
            if (video.paused) {
                video.play();
                $('.video-container').addClass('active');
                $(".video").addClass('active');

            }
        });

        pauseVid.click(function() {
            console.log('clicked');
            if (!video.paused) {
                video.pause();
                $('.video-container').removeClass('active');
                $(".video").removeClass('active');

            }
        });



        // var cursor = document.createElement('div');
        // cursor.classList.add('custom-cursor');
        // document.body.appendChild(cursor);
        //
        // var swiper = new Swiper(".mySwiper", {
        //     slidesPerView: 3,
        //     spaceBetween: 88,
        //     loop: true,
        //     loopedSlides: 1,
        //     freeMode: true,
        //     loopedSlidesLimit: false,
        //     pagination: {
        //         el: ".swiper-pagination",
        //         clickable: true,
        //     },
        //     navigation: {
        //         nextEl: ".swiper-button-next",
        //         prevEl: ".swiper-button-prev",
        //     },
        // });

        AOS.init({  duration: 1000 });


        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".card-slider",
                start: "top 50%", // Adjust the start position as needed
                toggleActions: "play",
            },
        });

        tl.to(".giant-circle", {
            opacity: 1,
            scale: 1,
            duration: 1,
            transformOrigin: "center",
        });



        var tl2 = gsap.timeline({
            scrollTrigger: {
                trigger: ".card-cta",
                start: "center 50%", // Adjust the start position as needed
                toggleActions: "play",
            },
        });

        tl2.to(".small-circle", {
            opacity: 1,
            scale: 1,
            duration: 1,
            transformOrigin: "center",
        });


        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: ".card-cta",
                start: "center 50%", // Adjust the start position as needed
                toggleActions: "play",
            },
        });

        tl3.to(".medium-circle", {
            opacity: 1,
            scale: 1,
            y: "-50%",
            duration: 1,
            transformOrigin: "center",
        });


//
//         // Toggle class on scroll
//         ScrollTrigger.create({
//             trigger: ".card-slider .content",
//             start: "top 50%", // Adjust the start position as needed
//             end: "bottom 20%", // Adjust the end position as needed
//             toggleClass: {
//                 targets: ".card-slider .content",
//                 className: "text--white",
//             },
//         });

        menuMain.init();

        // const lenis = new Lenis({
        //     duration: 1.2,
        //     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
        //     direction: 'vertical', // vertical, horizontal
        //     gestureDirection: 'vertical', // vertical, horizontal, both
        //     smooth: true,
        //     mouseMultiplier: 0.5,
        //     smoothTouch: false,
        //     touchMultiplier: 2,
        //     infinite: false,
        // });
        //
        // function raf(time) {
        //     lenis.raf(time)
        //     requestAnimationFrame(raf)
        // }
        //
        // requestAnimationFrame(raf);

        function initSwiper() {
            var swiperContainer = $('div[data-slider="mobileCards"]');
            if (swiperContainer.length) {
                var windowWidth = $(window).width();
                if (windowWidth < 992) {
                    // Initialize Swiper on mobile devices
                    var swiper = new Swiper('[data-slider="mobileCards"]', {
                        // Swiper options go here
                        slidesPerView: "auto",
                        spaceBetween: 30,
                        effect: 'cards',
                        loop: true,
                        centeredSlides: true,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        // If we need pagination
                        pagination: {
                            el: '.swiper-pagination-mobile',
                        },
                    });
                } else {
                    // Remove Swiper if initialized on a previous resize
                    var swiper = swiperContainer[0].swiper;
                    if (swiper) {
                        swiper.destroy(true, true);
                    }
                }
            }
        }

        initSwiper();
        // Re-initialize Swiper on window resize
        $(window).resize(initSwiper);

        var swiperCard = new Swiper('.cardSlider', {
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            centeredSlides: true,
            freeMode: true, // Enable free scrolling
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 640px
                640: {
                    spaceBetween: 30
                }
            }
        });

        var swiper = new Swiper('.gallerySlider', {
            slidesPerView: "auto",
            spaceBetween: 0,
            loop: true,
            centeredSlides: true,
            freeMode: true, // Enable free scrolling

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 640px
                640: {
                    spaceBetween: 15
                }
            }
        });



    }, 400 );

    setTimeout( () => {

        // scroll.update();

    }, 2000 );

    $(window).on('scroll', function (event) {
        AOS.refresh();
    });


} )( jQuery );

$(function(){



})

document.addEventListener("DOMContentLoaded", function() {
    const cursor = document.querySelector(".custom-cursor");
    const elements = document.querySelectorAll("[data-cursor]");

    function moveCursor(e) {
        gsap.to(cursor, {
            x: e.clientX,
            y: e.clientY
        });
    }

    function addHoverEffect() {
        const hoverText = this.getAttribute("data-hover");
        $(cursor).find('span').html(hoverText);
        if(hoverText == 'Drag'){
            $(cursor).addClass('arrows');
        }
        $(cursor).addClass('hovered');
        gsap.to(cursor, {
            duration: 0.3,
            width: "180px",
            height: "180px",
            ease: "power2.out"
        });
    }

    function removeHoverEffect() {
        $(cursor).find('span').html("");
        $(cursor).removeClass('hovered');
        $(cursor).removeClass('arrows');
        gsap.to(cursor, {
            duration: 0.3,
            width: "20px",
            height: "20px",
            ease: "power2.out"
        });
    }

    window.addEventListener("mousemove", moveCursor);

    elements.forEach(function(element) {
        element.addEventListener("mouseenter", addHoverEffect);
        element.addEventListener("mouseleave", removeHoverEffect);
    });
});

/***************
 * After theme scripts
 ***************/
// // Each time the window updates, refresh ScrollTrigger and then update LocomotiveScroll
// ScrollTrigger.addEventListener( 'refresh', () => scroll.update() );
//
// // After everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
// ScrollTrigger.refresh();